import { Link, useLocation, useSearchParams } from "react-router-dom";
import { AuthPageLayout } from "./auth-page-layout";
import { buttonVariants } from "@/components/ui/button";
import { getMailProvider } from "./mail-provider";
import { resolveSafeNext, withNext } from "./next-redirect";
import { useT } from "@/i18n";
import { authMessages } from "@/i18n/messages/auth";

export function RegisterSuccessPage() {
  const t = useT(authMessages);
  const location = useLocation();
  const email = (location.state as { email?: string })?.email ?? "";
  // `next` may arrive via router state (same-tab nav from /auth/register)
  // or via the URL query (deep link, refresh). State is preferred but the
  // URL is the durable fallback.
  const stateNext = (location.state as { next?: string | null })?.next ?? null;
  const [searchParams] = useSearchParams();
  const nextUrl =
    resolveSafeNext(stateNext) ?? resolveSafeNext(searchParams.get("next"));
  const mailProvider = email ? getMailProvider(email) : null;

  return (
    <AuthPageLayout>
      <div className="auth-state-stack" data-testid="register-success">
        <h2 className="auth-page-title">{t("checkEmail")}</h2>

        <p className="auth-page-copy">
          {email ? (
            <span className="font-semibold text-primary">{email}</span>
          ) : (
            t("verificationLinkSent")
          )}
        </p>

        {mailProvider ? (
          <>
            <a
              href={mailProvider.url}
              target="_blank"
              rel="noopener noreferrer"
              className={buttonVariants({
                variant: "secondary",
                size: "lg",
                className: "auth-liquid-primary-button w-full font-semibold",
              })}
              data-testid="open-mail-link"
            >
              {t("openMailProvider", { provider: mailProvider.label })}
            </a>
            <Link
              to={withNext("/auth/login", nextUrl)}
              className="auth-small-link"
              data-testid="back-to-login"
            >
              {t("signIn")}
            </Link>
          </>
        ) : (
          <Link
            to={withNext("/auth/login", nextUrl)}
            className={buttonVariants({
              variant: "secondary",
              size: "lg",
              className: "auth-liquid-primary-button w-full font-semibold",
            })}
            data-testid="back-to-login"
          >
            {t("signIn")}
          </Link>
        )}
      </div>
    </AuthPageLayout>
  );
}
